/**
 * "Trust, privacy & compliance" overview — Trust section (ADR-0074).
 * A docs-level map over Syncanix's trust posture that links out to the deeper
 * Trust Center pages (/trust/*) and the existing Core-concepts pages, rather
 * than restating legal text. Reconciled against product/trust/* and the
 * marketing trust content (compliance-status.json, subprocessors.json).
 */
import type { DocPageContent } from '../types';

export const TRUST_OVERVIEW_PAGE: DocPageContent = {
  slug: 'trust',
  titleKey: 'docs.trust.overview.title',
  descriptionKey: 'docs.trust.overview.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.trust.overview.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'commitments',
      textKey: 'docs.trust.overview.commitments.heading',
    },
    { kind: 'paragraph', textKey: 'docs.trust.overview.commitments.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.trust.overview.commitment.residency',
        'docs.trust.overview.commitment.isolation',
        'docs.trust.overview.commitment.control',
        'docs.trust.overview.commitment.transparency',
      ],
    },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.trust.overview.hub.title',
      textKey: 'docs.trust.overview.hub.body',
      links: {
        trust: { target: { path: '/trust' }, labelKey: 'docs.common.link.trust' },
      },
    },

    { kind: 'heading', level: 2, id: 'explore', textKey: 'docs.trust.overview.explore.heading' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.trust.overview.card.residency.title',
          textKey: 'docs.trust.overview.card.residency.text',
          to: { docSlug: 'trust/residency' },
        },
        {
          titleKey: 'docs.trust.overview.card.data.title',
          textKey: 'docs.trust.overview.card.data.text',
          to: { docSlug: 'trust/data' },
        },
        {
          titleKey: 'docs.trust.overview.card.privacy.title',
          textKey: 'docs.trust.overview.card.privacy.text',
          to: { docSlug: 'trust/privacy' },
        },
        {
          titleKey: 'docs.trust.overview.card.compliance.title',
          textKey: 'docs.trust.overview.card.compliance.text',
          to: { docSlug: 'trust/compliance' },
        },
        {
          titleKey: 'docs.trust.overview.card.ai.title',
          textKey: 'docs.trust.overview.card.ai.text',
          to: { docSlug: 'trust/ai' },
        },
        {
          titleKey: 'docs.trust.overview.card.memory.title',
          textKey: 'docs.trust.overview.card.memory.text',
          to: { docSlug: 'memory' },
        },
      ],
    },
  ],
};
